import {
    setRegionPrefixToFetch,
    addRegionToURL,
} from 'security/src/FetchUtils';

export { setRegionPrefixToFetch, addRegionToURL };
